import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_InputText = _resolveComponent("InputText")
  const _component_Column = _resolveComponent("Column")
  const _component_DataTable = _resolveComponent("DataTable")
  const _component_Card = _resolveComponent("Card")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--secondary p-mt-2 p-mx-2" }, {
      start: _withCtx(() => [
        (!_ctx.expandTableCard)
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 0,
              icon: "fas fa-chevron-right",
              class: "p-button-text p-button-rounded p-button-plain",
              style: {"color":"white"},
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.expandTableCard = true))
            }))
          : (_openBlock(), _createBlock(_component_Button, {
              key: 1,
              icon: "fas fa-chevron-down",
              class: "p-button-text p-button-rounded p-button-plain",
              style: {"color":"white"},
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.expandTableCard = false))
            })),
        _createTextVNode(" " + _toDisplayString(_ctx.$t('managers.datasetManagement.queryParamTable')), 1)
      ]),
      end: _withCtx(() => [
        _createVNode(_component_Button, {
          icon: "fas fa-plus",
          class: "p-button-text p-button-rounded p-button-plain",
          onClick: _ctx.addNewParam
        }, null, 8, ["onClick"]),
        _createVNode(_component_Button, {
          icon: "fas fa-eraser",
          class: "p-button-text p-button-rounded p-button-plain",
          disabled: _ctx.disableDeleteAll,
          onClick: _ctx.removeAllParams
        }, null, 8, ["disabled", "onClick"])
      ]),
      _: 1
    }),
    _withDirectives(_createVNode(_component_Card, { class: "p-mx-2" }, {
      content: _withCtx(() => [
        _createVNode(_component_DataTable, {
          class: "p-datatable-sm kn-table",
          editMode: "cell",
          value: _ctx.dataset.restRequestAdditionalParameters,
          scrollable: true,
          scrollHeight: "250px",
          dataKey: "versNum",
          responsiveLayout: "stack",
          breakpoint: "960px",
          onCellEditComplete: _ctx.onCellEditComplete
        }, {
          empty: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('managers.datasetManagement.tableEmpty')), 1)
          ]),
          default: _withCtx(() => [
            _createVNode(_component_Column, {
              field: "name",
              header: _ctx.$t('kpi.alert.name'),
              sortable: true
            }, {
              editor: _withCtx(({data}) => [
                _createVNode(_component_InputText, {
                  class: "kn-material-input",
                  style: _ctx.tableDescriptor.style.columnStyle,
                  modelValue: data.name,
                  "onUpdate:modelValue": ($event: any) => (data.name = $event)
                }, null, 8, ["style", "modelValue", "onUpdate:modelValue"])
              ]),
              _: 1
            }, 8, ["header"]),
            _createVNode(_component_Column, {
              field: "value",
              header: _ctx.$t('common.value'),
              sortable: true
            }, {
              editor: _withCtx(({data}) => [
                _createVNode(_component_InputText, {
                  class: "kn-material-input",
                  style: _ctx.tableDescriptor.style.columnStyle,
                  modelValue: data.value,
                  "onUpdate:modelValue": ($event: any) => (data.value = $event)
                }, null, 8, ["style", "modelValue", "onUpdate:modelValue"])
              ]),
              _: 1
            }, 8, ["header"]),
            _createVNode(_component_Column, { onRowClick: false }, {
              body: _withCtx((slotProps) => [
                _createVNode(_component_Button, {
                  icon: "pi pi-trash",
                  class: "p-button-link",
                  onClick: ($event: any) => (_ctx.deleteParam(slotProps))
                }, null, 8, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["value", "onCellEditComplete"])
      ]),
      _: 1
    }, 512), [
      [_vShow, _ctx.expandTableCard]
    ])
  ], 64))
}